import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIsServicesEnabled } from '../../../../actions/publishTerms';

import { ServicesLayoutToggle } from './ServicesLayoutToggle';
import { useToggleLabel } from './hooks';
import { selectIsServicesPromotionToggleChecked } from '../../../../reducers/v2/promotion/selectors';
import { selectIsDisabledPromotion } from '../../../../selectors/publishTerms';

export const ServicesLayoutToggleContainer = () => {
  const dispatch = useDispatch();
  const isPromotionDisabled = useSelector(selectIsDisabledPromotion);
  const isToggleChecked = useSelector(selectIsServicesPromotionToggleChecked);
  const { showLabel } = useToggleLabel();

  const handleToggleChange = React.useCallback(
    (value: boolean) => {
      dispatch(setIsServicesEnabled(value));
    },
    [dispatch],
  );

  return (
    <ServicesLayoutToggle
      checked={isToggleChecked}
      disabled={isPromotionDisabled}
      showLabel={showLabel}
      onChange={handleToggleChange}
    />
  );
};
